import React from "react";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Snackbar,
  Slide,
} from "@material-ui/core";
import Http from "../../../Http";
import { withRouter } from "react-router-dom";
import moment from "moment";
import EnviarFacturaEmail from "../Facturar/EnviarFacturaEmail";

class GuiasClienteTable extends TableComponent {
  componentDidMount() {
    const { id_cliente, start_date, end_date, id, guias } = this.props;
    if (guias && guias.length > 0) {
      this.setState({ guias });
    }
    this.tableConfig(
      {
        dataUrl: `facturacion/search/guiasbycliente?cliente_id=${id_cliente}&start_date=${start_date}&end_date=${end_date}&id=${id}`,
        deleteUrl: false,
        deleteField: false,
        modUrl: false,
      },
      TableOp.Table("Guias", [
        {
          label: "Facturar",
          id: "recibida",
          type: "checkbox",
          callback: this.onValueChange,
        },
        { label: "Guia", id: "g_folio" },
        { label: "Total de la guia", id: "g_costo_total" },
        { label: "Cliente", id: "cliente_rsocial" },
        { label: "Origen", id: "g_origen" },
        { label: "Destino", id: "g_destino" },
      ])
    );
    this.table();
    this.inputFileRef = React.createRef();
  }

  uploadFile = () => {
    this.inputFileRef.current.click();
  };

  async table(page = this.page, limit = this.rpp, q = this.q, orderBy = this.orderBy, order = this.order) {
    this.page = page;
    this.rpp = limit;
    this.setState({ loading: true });
    try {
      if (!q) {
        const urlParams = new URLSearchParams(window.location.search);
        q = urlParams.get("qt");
        let pages = urlParams.get("page");
        if (pages) {
          page = parseInt(pages);
          this.page = page;
        }
      }
      if (!this.config.dataUrl) {
        return false;
      }
      const nexo =
        this.config.dataUrl && this.config.dataUrl.includes("?") ? "&" : "?";
      let Res = await Http.get(
        `${this.config.dataUrl}${nexo}p=${page}&l=${limit}${
          q ? `&q=${q}` : ""
        }${orderBy ? `&orderBy=${orderBy}&order=${order}` : ""}`
      );
      Res.data.rows = Res.data.rows.map((row, i) => {
        if (this.state.guias && this.state.guias.some((guia) => guia === row.id)) {
          row["recibida"] = true;
        }
        return row;
      });

      this.setState({
        tableData: {
          ...this.state.tableData,
          rows: Res.data.rows,
          total: Res.data.total,
          q,
          page: this.page,
        },
        loading: false,
      });
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id_cliente !== this.props.id_cliente) {
      const { id_cliente, start_date, end_date } = this.props;
      this.config.dataUrl = `facturacion-search/guiasbycliente?cliente_id=${id_cliente}&start_date=${start_date}&end_date=${end_date}`;
      this.table();
    }
    if (prevProps.loading !== this.props.loading) {
      this.setState({ loading: this.props.loading });
    }
  }

  onValueChange = (event, index, field) => {
    let { tableData, guias = [] } = this.state;
    let value = event.target.value;
    let rows = [];
    rows = tableData.rows.slice();
    rows[index][field] = value;
    if (value) {
      guias.push(rows[index].id);
    } else {
      guias = guias.filter((guia) => guia !== rows[index].id);
    }
    this.setState({ tableData: { ...tableData, rows }, guias });
    this.props.onChangeGuias(guias);
  };

  handledownloadFile = async (type) => {
    let id_guia = null;
    for (const guia of this.state.tableData.rows) {
      if (guia.recibida) {
        id_guia = guia.id;
      }
    }
    const Resp = await Http.post(
      "facturacion/file",
      { id_guia, type },
      true,
      "arraybuffer"
    );
    if (Resp) {
      const blob = new Blob([Resp], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = `${id_guia}.xml`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      // this.props.history.goBack();
    }
  };

  handleDownloadFiles = async () => {
    await this.handledownloadPdf();
    await this.handledownloadFile("xml-timbrado");
  };

  handledownloadPdf = () => {
    const { pdfURL } = this.state;
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = pdfURL;
    a.download = `factura.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
    // this.props.history.goBack();
  };

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
    this.props.history.goBack();
  };

  onFileUpload = async (e) => {
    let form = new FormData();
    form.append("file", e.target.files[0]);
    form.append("id_factura", this.props.id);
    form.append("id_cliente", this.props.id_cliente);
    try {
      let res = await Http.post(`facturacion/save-guias-file`, form);
      if (!res.error) {
        this.setState({ sbOpen: true, sbMsg: res.data || "Guardado Correctamente" });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({ sbOpen: true, sbMsg: res.errMsg });
      }
      this.inputFileRef.current.value = null;
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { viewPdf, loading, sbOpen, sbMsg, guias = [], factura } = this.state;

    return (
      <div
        style={{
          padding: 15,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong>Cantidad de guias seleccionadas: {guias.length}</strong>
          {this.props.id && !this.props.timbrado && (
            <>
              <Button variant="contained" onClick={this.uploadFile} >Subir guias</Button>
              <input
                type="file"
                hidden={true}
                ref={this.inputFileRef}
                accept=".csv"
                onChange={this.onFileUpload}
              />
            </>
          )}
        </div>
        <this.TableRender />
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 10,
          }}
        >
          {this.props.previsualizar && (
            <Button
              variant="contained"
              color="default"
              style={{ marginRight: 20 }}
              disabled={loading || this.props.loadingPreview || this.props.disabled}
              onClick={this.props.previsualizar}
            >
              {this.props.loadingPreview && (
                <div style={{ marginRight: 10, padding: 0, height: 22 }}>
                  <CircularProgress size={20} />
                </div>
              )}
              Previsualizar Factura
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 20 }}
            disabled={loading || this.props.disabled}
            onClick={() => this.props.facturar(true)}
          >
            <div
              style={{ marginRight: 10, padding: 0, height: 22 }}
              hidden={!loading}
            >
              <CircularProgress color="secondary" size={20} />
            </div>
            Guardar y Timbrar
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={loading || this.props.disabled}
            onClick={() => this.props.facturar(false)}
          >
            <div
              style={{ marginRight: 10, padding: 0, height: 22 }}
              hidden={!loading}
            >
              <CircularProgress color="secondary" size={20} />
            </div>
            Guardar
          </Button>
        </div>

        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle>Reenviar Factura</DialogTitle>
          <DialogContent>
            <EnviarFacturaEmail factura={factura} />
          </DialogContent>
        </Dialog>
        <Snackbar
          open={sbOpen}
          onClose={() => {
            this.setState({ sbOpen: false });
          }}
          TransitionComponent={Slide}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{sbMsg}</span>}
        />
      </div>
    );
  }
}

export default withRouter(GuiasClienteTable);
